module.exports = __webpack_public_path__ + "img/logo-text-green.2137bfaa.png";